import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["channelCard", "counterNumber"]

  connect() {
    this.salesCount = 0
    this.currentIndex = 0
    this.startSimulation()
  }

  disconnect() {
    if (this.simulationInterval) {
      clearInterval(this.simulationInterval)
    }
  }

  startSimulation() {
    // Start simulation after initial animation
    setTimeout(() => {
      this.simulateSale()
      this.simulationInterval = setInterval(() => this.simulateSale(), 2000)
    }, 1000)
  }

  simulateSale() {
    if (this.channelCardTargets.length === 0) return

    const card = this.channelCardTargets[this.currentIndex]
    card.classList.add('pulse')

    // Increment sales
    this.salesCount += Math.floor(Math.random() * 5) + 1
    this.counterNumberTarget.textContent = this.salesCount

    // Remove pulse animation
    setTimeout(() => {
      card.classList.remove('pulse')
    }, 500)

    // Move to next channel
    this.currentIndex = (this.currentIndex + 1) % this.channelCardTargets.length
  }
}
